import { Lock, Compass, UserCheck } from "lucide-react";

export const PhilosophySection = () => {
  return (
    <section
      data-testid="philosophy-section"
      className="relative bg-[#040812] py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <span className="overline">/03 · Corporate Philosophy</span>
            <h2 className="mt-6 font-display text-white text-4xl md:text-5xl lg:text-6xl tracking-tighter font-light leading-[1.05]">
              100% bootstrapped.
              <br />
              Founder-led.
              <br />
              <span className="text-red-500">Uncompromised.</span>
            </h2>
            <p className="mt-8 text-slate-400 text-base md:text-lg leading-relaxed">
              We took no venture capital. We answer to no board. Every
              engineering, compliance and operational decision at Sriman
              Solutions is made by the founding team — with the sole objective
              of preserving absolute operational autonomy and uncompromised data
              privacy for the enterprises we serve.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-3 gap-4">
            {[
              {
                icon: Lock,
                title: "Data Sovereignty",
                text: "Client data never touches shared infrastructure. Every deployment is tenant-isolated, self-hosted where required, and auditable end-to-end.",
              },
              {
                icon: Compass,
                title: "Operational Autonomy",
                text: "No external investors, no growth-at-all-costs pressure. Every decision is measured against long-term client trust — not next quarter.",
              },
              {
                icon: UserCheck,
                title: "Founder Accountability",
                text: "Senior founders remain on every engagement. Escalation paths are short, direct, and personally owned.",
              },
            ].map(({ icon: Icon, title, text }) => (
              <div
                key={title}
                className="bg-[#0B132B]/50 border border-white/10 p-8 hover-lift"
              >
                <Icon size={18} className="text-red-500" strokeWidth={1.5} />
                <h3 className="mt-6 font-display text-white text-lg tracking-tight">
                  {title}
                </h3>
                <p className="mt-4 text-slate-400 text-sm leading-relaxed">
                  {text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
